import {
  collection,
  doc,
  getDoc,
  setDoc,
  writeBatch,
  increment,
} from 'firebase/firestore'

import { firestore } from '../firebase/firebaseConfig'
import { guardedCall } from '../firebase/requestGuard'
import { NewLog, Student } from '../types'

const studentsRef = collection(firestore, 'students')

export async function createStudent(newStudent: Student) {
  return guardedCall(async () => {
    const ref = doc(studentsRef)
    await setDoc(ref, { ...newStudent, uid: ref.id })
    return ref.id
  })
}

export async function getStudent(studentId: string) {
  return guardedCall(async () => {
    const ref = doc(studentsRef, studentId)
    const snap = await getDoc(ref)
    if (!snap.exists()) throw new Error('not-found')
    return snap.data() as Student
  })
}

export async function saveStudent(student: Student) {
  return guardedCall(async () => {
    const ref = doc(studentsRef, student.uid)
    await setDoc(ref, student, { merge: true })
  })
}

export async function upsertLog(
  studentId: string,
  log: NewLog,
  cuponId: string | null,
) {
  return guardedCall(async () => {
    const studentRef = doc(studentsRef, studentId)
    const logsCol = collection(studentRef, 'logs')
    const logId = log.uid ?? doc(logsCol).id
    const logRef = doc(logsCol, logId)
    const batch = writeBatch(firestore)

    batch.set(logRef, { ...log, uid: logId, cuponId }, { merge: true })

    batch.update(studentRef, { currentAttendance: increment(1) })
    await batch.commit()
    return logId
  })
}
